/** Site root with trailing slash, e.g. https://sugarcribs.com/ */
function siteRootFromOrigin(origin: string): string {
  const trimmed = origin.replace(/\/+$/, "");
  return `${trimmed}/`;
}

/**
 * Platform Organization node for JSON-LD @graph (WebSite publisher, ProfilePage publisher, etc.).
 */
export function buildPlatformOrganization(origin: string): {
  "@type": "Organization";
  "@id": string;
  name: string;
  legalName: string;
  url: string;
  logo: { "@type": "ImageObject"; url: string };
  description: string;
  email: string;
} {
  const root = siteRootFromOrigin(origin);
  return {
    "@type": "Organization",
    "@id": `${root}#organization`,
    name: "Sugar Cribs",
    legalName: "TOPV1 LLC",
    url: root,
    logo: {
      "@type": "ImageObject",
      url: `${root}logo512.png`,
    },
    description:
      "Discover creators, unlock exclusive content, and connect on Sugar Cribs.",
    email: "support@sugarcribs.com",
  };
}
